// Dente #4 (céticos 2026-07-06) — produtor do SHA de verificação: o HEAD do
// worktree no fim do run viaja na turn_telemetry → o Worker carimba
// metadata.headSha nos skill_outcomes → a graduação detecta drift de ambiente
// (skillVerificationState stale_sha deixa de ser latente). Best-effort.

export async function gitHeadSha(root) {
  try {
    const w = /** @type {any} */ (typeof window !== 'undefined' ? window : null);
    const api = w?.apolo || null;
    if (!root || !api?.shell?.exec) return null;
    const res = await api.shell.exec({ command: 'git rev-parse --short=12 HEAD', cwd: root, runId: `sha-${root.length}` });
    const out = String(res?.stdout || '').trim();
    return res?.ok !== false && /^[0-9a-f]{7,40}$/i.test(out) ? out : null;
  } catch { return null; }
}
